import { MrfiktivAttachmentsViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { SignDocumentDataAccessLayer } from "@/store/modules/access-layers/sign-document.access-layer";
import { ISignDocument, SignDocument } from "./sign-document.entity";

class AttachmentsBase implements MrfiktivAttachmentsViewModelGen {
  documentIds: string[];

  constructor(data?: MrfiktivAttachmentsViewModelGen) {
    this.documentIds = data?.documentIds ?? [];

    for (const doc of data?.documents ?? []) {
      SignDocumentDataAccessLayer.set(new SignDocument(doc as any));
    }
  }

  get documents(): ISignDocument[] {
    return this.documentIds
      .map((id) => SignDocumentDataAccessLayer.maps.id.get(id)?.[0])
      .filter((doc): doc is ISignDocument => Boolean(doc));
  }

  get dto() {
    return { documentIds: this.documentIds };
  }
}

type IAttachments = AttachmentsBase;
class Attachments extends AttachmentsBase {}

export { Attachments, IAttachments };
